import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';
import MainLayout from '@components/layout/MainLayout';

// Code-split pages with React.lazy for smaller initial bundle
const SinglePage = lazy(() => import('@pages/SinglePage'));

export const router = createBrowserRouter([
    {
      path: '/',
      element: <MainLayout />,
      children: [
        { path: '/', element: <SinglePage /> },
        { path: '/experience', element: <SinglePage /> },
        { path: '/skills', element: <SinglePage /> },
        { path: '/projects', element: <SinglePage /> },
        { path: '/contact', element: <SinglePage /> },
      ],
    },
]);